import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import { TextField as TextFieldOrigin } from "mui-rff";

import { styles } from "./TextField.styles";

function TextField({ classes, id, type, label, required, placeholder }) {
  return (
    <div className={classes.root}>
      <TextFieldOrigin
        className={classes.textfield}
        id={id}
        type={type}
        label={label}
        name={id}
        margin="none"
        size="small"
        required={required}
        placeholder={placeholder}
      />
    </div>
  );
}

export default withStyles(styles)(TextField);
